<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 py-0">
              <upload-image-direct
                @inputChanged="uplodeImg_1"
                model="users"
                placeHolder="صورة العميل"
              ></upload-image-direct>
              <!-- End:: Image -->
            </div>
            <!-- Start:: Image -->

            <!-- Start:: Name -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="data.full_name"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.name") }}*
                </label>
              </div>
            </div>
            <!-- End:: Name -->

            <!-- Start:: Email -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="email"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.email"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.email") }}*
                </label>
              </div>
            </div>
            <!-- End:: Email -->

            <!-- Start:: phone_code -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.phone_code") }}*
                </label>
                <multiselect
                  :loading="!countries.length"
                  v-model="data.phone_code"
                  :options="countries"
                  label="phone_code"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <!-- Start:: Country -->

            <!-- Start:: Phone -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.phone"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.phone") }}*
                </label>
              </div>
            </div>
            <!-- End:: Phone -->

            <!-- Start:: Country -->
            <!-- <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.country") }}*
                </label>
                <multiselect
                  v-model="data.country"
                  :options="countries"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                  @input="
                    getCities(data.country.id);
                    getRegions(data.country.id);
                    data.city = null;
                    data.region = null;
                  "
                ></multiselect>
              </div>
            </div> -->
            <!-- Start:: Country -->

            <!-- Start:: Cities -->
            <!-- <div class="col-lg-4 py-0">
              <div
                class="input_wrapper top_label"
                :class="{ disabled: !data.country }"
              >
                <label class="form-label">
                  {{ $t("forms.labels.city") }}*
                </label>
                <multiselect
                  v-model="data.city"
                  :options="cities"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div> -->
            <!-- Start:: Cities -->
            <!-- Start:: role -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label">
                  {{ $t("forms.labels.role") }}*
                </label>
                <multiselect
                  :loading="!roles.length"
                  v-model="data.role"
                  :options="roles"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>
            <!-- Start:: role -->
            <!-- Start:: Region -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> المناطق* </label>
                <multiselect
                  :loading="!regions.length"
                  v-model="data.regions"
                  :options="regions"
                  :multiple="true"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
              <!-- <div
                class="pr-3"
                style="
                  font-size: 14px;
                  margin-top: -20px;
                  border-radius: 5px;
                  color: orange;
                "
              >
                يرجي ا
              </div> -->
            </div>
            <!-- Start:: Region -->

            <!-- Start:: Password -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="password"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.password"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.password") }}*
                </label>
              </div>
            </div>
            <!-- End:: Password -->

            <!-- Start:: Password  Confirmation-->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="password"
                  class="form-control"
                  v-model.trim="data.password_confirmation"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.confirmPassword") }}*
                </label>
              </div>
            </div>
            <!-- End:: Password  Confirmation-->

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.max_daily_deposit_amount"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.max_daily_deposit_amount") }}*
                </label>
              </div>
            </div>

            <!-- Start:: Is Active -->
            <div class="col-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="#783D73"
              ></v-checkbox>
            </div>
            <!-- End:: Is Active -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.clients.title"),
          disabled: false,
          href: "/admins/show-all",
        },
        {
          text: this.$t("breadcrumb.clients.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data To Send
      data: {
        avatar: null,
        full_name: null,
        email: null,
        phone_code: null,
        phone: null,
        country: null,
        nationality: null,
        city: null,
        regions: null,
        password: null,
        password_confirmation: null,
        is_active: true,
        role: null,
        max_daily_deposit_amount: null,
      },

      // ========== Fixed Data
      countries: [],
      cities: [],
      regions: [],
      roles: [],
    };
  },

  methods: {
    // ============ Get Select Lists Data
    getRoles() {
      this.$axios({
        method: "GET",
        url: `Role_not_paginated`,
      })
        .then((res) => {
          this.roles = res.data.data;
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getCountries() {
      this.$axios({
        method: "GET",
        url: `country_not_paginated`,
      })
        .then((res) => {
          this.countries = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
              phone_code: item.phone_code,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getCities(countryId) {
      this.$axios({
        method: "GET",
        url: `city_not_paginated`,
        params: {
          country_id: countryId,
        },
      })
        .then((res) => {
          this.cities = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },
    getRegions() {
      this.$axios({
        method: "GET",
        url: `region_not_paginated`,
      })
        .then((res) => {
          this.regions = res.data.data.map((item) => {
            return {
              id: item.id,
              name: `${item.name}`,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.avatar = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.avatar) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.image"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.full_name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.email) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.email"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.role) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.role"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone_code) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone_code"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phone) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.phone"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length < 9) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اكبر من 9 ارقام",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phone.length > 11) {
        this.$iziToast.error({
          timeout: 2000,
          message: "رقم الهاتف يجب ان يكون اقل من 11 رقم",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.password) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.password"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.password != this.data.password_confirmation) {
        this.$iziToast.error({
          timeout: 2000,
          message: "تاكيد الباسورد يجب  ان يساوي الباسورد",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("image", this.data.avatar);

      submit_data.append("full_name", this.data.full_name);
      submit_data.append("phone_code", this.data.phone_code.phone_code);
      submit_data.append("phone", this.data.phone);
      submit_data.append("role_id", this.data.role.id);
      submit_data.append(
        "max_daily_deposit_amount",
        this.data.max_daily_deposit_amount
      );

      // if (this.data.country) {
      //   submit_data.append("country_id", this.data.country.id);
      // }
      // if (this.data.city) {
      //   submit_data.append("city_id", this.data.city.id);
      // }
      if (this.data.region) {
        submit_data.append("region_id", this.data.region.id);
      }
      submit_data.append("email", this.data.email);
      this.data.regions.forEach((el, index) => {
        submit_data.append(`regions[${index}]`, el.id);
      });
      // submit_data.append('location_description', this.data.location_description)
      // submit_data.append('lat', this.coordinates_to_edit.lat)
      // submit_data.append('lng', this.coordinates_to_edit.lng)

      submit_data.append("password", this.data.password);
      submit_data.append("is_active", +this.data.is_active);

      this.$axios({
        method: "POST",
        url: "admin",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/admins/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // Empty Form Data
    emptyFormData() {
      this.data.avatar = null;
      this.full_name = null;
      this.email = null;
      this.phone_code = null;
      this.phone = null;
      this.country = null;
      this.city = null;
      this.region = null;
      this.password = null;
      this.password_confirmation = null;
    },
  },

  created() {
    // Start:: Fire Methods
    this.getRoles();
    this.getCountries();
    this.getRegions();
    // End:: Fire Methods
  },
};
</script>
